<template>
<div style="display: contents">
  <div v-if="isTestDetailsPresent" class="fill-details">
    <div id="left-pane">
      <div class="test-details">
        <img id="image" src="../assets/fill-details.svg" alt="Fill Details" />
        <p id="sample-test">{{ $store.state.test.name }}</p>
        <table rules="rows" class="parent-test-details">
          <tr>
            <td class="test-details-left-column">By</td>
            <td class="test-details-right-column" style="color: #0988F4;">
              {{ $store.state.test.companyName }}
            </td>
          </tr>
          <tr>
            <td class="test-details-left-column">Duration</td>
            <td class="test-details-right-column">
              {{ $store.getters.getDuration }} hours
            </td>
          </tr>
          <tr>
            <td class="test-details-left-column">Opens At</td>
            <td class="test-details-right-column">
              {{ $store.getters.getFormattedDate }}
            </td>
          </tr>
        </table>
      </div>
      <div
        class="system-compatible"
        :class="
          compatible ? 'system-compatible-green' : 'system-compatible-red'
        "
      >
        <div class="symbol-div">
          <img v-if="compatible" src="../assets/pass_green.svg" />
          <img v-else src="../assets/Cross_Symbol.svg" />
        </div>
        <div class="system-compatible-msg">{{ sytemCompatibleMsg }}</div>
      </div>
      <div class="help-section">
        <hr class="horizontal-line" />
        <div class="help-div">
          <p id="recommended">Recommended before you start test</p>
          <p id="recommended-para">
            Before taking {{ $store.state.test.name }}, it is recommended that
            you take a practice test.
          </p>
          <button class="practice-test" @click="practiceTest">
            TAKE PRACTICE TEST
          </button>
          <p id="help-support">Help and support</p>
          <p id="contact-administrator">
            Please contact the administrator at
            <a
              href="mailto:headstart-support@infocusp.com"
              target="_top"
              style="color: #319BF5"
              >headstart-support@infocusp.com</a
            >
          </p>
        </div>
      </div>
    </div>
    <div class="right-pane">
      <Modal
        v-if="showModal"
        :browser="browser"
        :screen-size="screen_size"
        :os="os"
        :time-mismatch="false"
        @close="showModal = false"
      ></Modal>
      <div v-if="compatible" class="test-not-started-container">
        <div class="timer-div">
          <div class="date-countdown">
            <div class="minLeft"><!--Test Starts In--></div>
            <div class="time-container">
              <div id="hours" class="time-block">
                <div class="time-value">
                  <div class="time-count">{{ diffHrs }}</div>
                </div>
                <div class="unit-text">Hours</div>
              </div>
              <div class="colon">:</div>
              <div id="minutes" class="time-block">
                <div class="time-value">
                  <div class="time-count">{{ diffMins }}</div>
                </div>
                <div class="unit-text">Mins</div>
              </div>
              <div class="colon">:</div>
              <div id="seconds" class="time-block">
                <div class="time-value">
                  <div class="time-count">{{ diffSecs }}</div>
                </div>
                <div class="unit-text">Secs</div>
              </div>
            </div>
          </div>
          <img
            class="timer-img"
            src="../assets/test_status/timer_without_mins.svg"
            alt="Timer"
          />
        </div>
        <div class="msg-container">
          <div class="msg-div">
            <h2>Test has not started yet !!</h2>
            <img src="../assets/hs_logo_text.svg" alt="HeadStart" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="!isTestDetailsPresent">
    <div class="msg-container">
      <div class="msg-div">
        <h2>Please close this tab and open the test URL again!</h2>
        <img src="../assets/hs_logo_text.svg" alt="HeadStart" />
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import Modal from './Modal'
import api from '../services/api.service'
export default {
  name: 'TestNotStarted',
  components: { Modal },
  data: function() {
    return {
      diffHrs: Number,
      diffMins: Number,
      diffSecs: Number,
      timerId: Number,
      showModal: false,
      compatible: true,
      sytemCompatibleMsg: '',
      os: {
        os_name: '',
        os_allowed: '',
      },
      browser: {
        browser_name: '',
        browser_allowed: '',
      },
      screen_size: {
        resolution: '',
        resolution_allowed: '',
      },
      xmlHttp: null,
      isTestDetailsPresent: true,
    }
  },
  created() {
    if (!this.$store.state.test.testId) {
      this.isTestDetailsPresent = false;
    }

    var temp = true
    Object.values(this.systemCheck()).forEach(function(value) {
      temp = temp & value
    })

    this.compatible = temp
    if (this.compatible) {
      this.sytemCompatibleMsg = 'System is compatible for the test'
    } else {
      this.sytemCompatibleMsg = 'System is not compatible for the test'
      this.showModal = true
    }

    this.updateTimeDiff()

    this.timerId = setInterval(() => {
      this.updateTimeDiff()
    }, 1000)
  },
  beforeDestroy() {
    clearInterval(this.timerId)
  },
  methods: {
    practiceTest: function() {
      window.open('https://headstart.infocusp.com/#/practice-test', '_blank')
    },
    updateTimeDiff() {
      // var st = this.srvTime()
      var today = new Date()
      var testStartDate = new Date(this.$store.state.test.startDateTime)
      var diffMs = testStartDate - today // milliseconds between now & Christmas
      if (testStartDate < today) {
        diffMs = 0
        var test_url =
          '/fill-details/test/' +
          this.$store.state.test.testId +
          '/user/' +
          btoa(this.$store.state.userEmail)
        this.$store.commit('setCurrentStep', 'webcam')
        this.$router.replace({ path: test_url })
      }
      var diffDays = Math.floor(diffMs / 86400000) // days
      this.diffHrs = Math.floor((diffMs % 86400000) / 3600000) + diffDays * 24 // hours
      this.diffMins = Math.floor(((diffMs % 86400000) % 3600000) / 60000) // minutes
      this.diffSecs = Math.floor(
        (((diffMs % 86400000) % 3600000) % 60000) / 1000
      ) // seconds

      if (this.diffHrs < 10) this.diffHrs = '0' + this.diffHrs
      if (this.diffMins < 10) this.diffMins = '0' + this.diffMins
      if (this.diffSecs < 10) this.diffSecs = '0' + this.diffSecs
    },
    systemCheck() {
      var ans = {
        browser_allowed: false,
        js_enabled: true,
        cookies_enabled: false,
        screen_size: false,
      }
      this.os.os_name = this.getOS()
      if (this.os.os_name) {
        this.os.os_allowed = true
      } else {
        this.os.os_allowed = false
      }

      navigator.sayswho = (function() {
        var ua = navigator.userAgent
        var N = navigator.appName
        var tem
        var M =
          ua.match(
            /(opera|chrome|safari|firefox|msie|trident)\/?\s*([\d\\.]+)/i
          ) || []
        M = M[2] ? [M[1], M[2]] : [N, navigator.appVersion, '-?']
        if (M && (tem = ua.match(/version\/([\\.\d]+)/i)) != null) M[2] = tem[1]
        return M.join(' ')
      })()

      var browser = navigator.sayswho
      var parts = browser.split(' ')
      browser = parts[0].toLowerCase()
      var version = parts[1]
      var versionParts = version.split('.')
      version = parseInt(versionParts[0])

      if (
        (browser === 'chrome' && version < 40) ||
        (browser === 'firefox' && version < 35) ||
        (browser === 'msie' && version < 11) ||
        (browser === 'safari' && version < 11) ||
        (browser === 'opera' && version < 27)
      ) {
        // this.$router.push('browser-not-supported')
        ans['browser_allowed'] = false
      } else {
        ans['browser_allowed'] = true
      }

      if (navigator.cookieEnabled) {
        ans['cookies_enabled'] = true
      }
      if (screen.width >= 1366 && screen.height >= 768) {
        ans['screen_size'] = true
      }
      this.browser.browser_name = browser
      this.browser.browser_allowed = ans['browser_allowed']
      this.screen_size.resolution = screen.width + ' X ' + screen.height
      this.screen_size.resolution_allowed = ans['screen_size']

      return ans
    },
    getOS() {
      var userAgent = window.navigator.userAgent
      var platform = window.navigator.platform
      var macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K']
      var windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE']
      var iosPlatforms = ['iPhone', 'iPad', 'iPod']
      var os = null

      if (macosPlatforms.indexOf(platform) !== -1) {
        os = 'Mac OS'
      } else if (iosPlatforms.indexOf(platform) !== -1) {
        os = 'iOS'
      } else if (windowsPlatforms.indexOf(platform) !== -1) {
        os = 'Windows'
      } else if (/Android/.test(userAgent)) {
        os = 'Android'
      } else if (!os && /Linux/.test(platform)) {
        os = 'Linux'
      }

      return os
    },
    srvTime() {
      try {
        //FF, Opera, Safari, Chrome
        this.xmlHttp = new XMLHttpRequest()
      } catch (err1) {
        //IE
        try {
          this.xmlHttp = new ActiveXObject('Msxml2.XMLHTTP')
        } catch (err2) {
          try {
            this.xmlHttp = new ActiveXObject('Microsoft.XMLHTTP')
          } catch (eerr3) {
            //AJAX not supported, use CPU time.
            alert('AJAX not supported')
          }
        }
      }
      this.xmlHttp.open('HEAD', window.location.href.toString(), false)
      this.xmlHttp.setRequestHeader('Content-Type', 'text/html')
      this.xmlHttp.send('')
      return this.xmlHttp.getResponseHeader('Date')
    },
  },
}
</script>

<style scoped>
.system-compatible-msg {
  margin: 8px;
  font-family: Roboto-Regular;
  font-size: 14px;
  letter-spacing: 0;
}

.symbol-div {
  margin: 8px;
}

.system-compatible-green {
  background: rgba(99, 219, 193, 0.1);
  color: #1bc09c;
}

.system-compatible-red {
  background: rgba(246, 105, 87, 0.1);
  color: #f66957;
}

.system-compatible {
  width: fit-content;
  border-radius: 2px;
  display: flex;
  flex-direction: row;
  margin-top: 16px;
  margin-left: 32px;
  min-height: 30px;
}

.fill-details {
  display: flex;
  margin-top: 64px;
  flex: 1;
  max-height: calc(100% - 64px);
}

#left-pane {
  background: #ffffff;
  box-shadow: inset -1px 0 0 0 #a8b2c6;
  display: flex;
  flex: 1;
  flex-direction: column;
  max-width: 376px;
}

#image {
  display: block;
  margin: 48px auto;
  height: 214px;
  width: 240px;
}

#sample-test {
  font-family: Roboto-Medium;
  font-size: 21px;
  color: #616262;
  letter-spacing: 0;
  margin-left: 32px;
}

.test-details-right-column {
  font-family: Roboto-Medium;
  color: #9b9b9b;
  letter-spacing: 0;
  padding: 16px 0;
}

.test-details-left-column {
  font-family: Roboto-Regular;
  color: #9b9b9b;
  letter-spacing: 0;
  padding: 0 32px;
}

.parent-test-details {
  border: none;
  margin-right: 32px;
  width: 326px;
}

.parent-test-details tr {
  border-top: solid thin;
  border-bottom: solid thin;
  border-color: #efeef3;
}

.practice-test {
  padding: 4px;
  border: 1px solid #1bc09c;
  border-radius: 2px;
  background-color: white;
  color: #1bc09c;
  text-align: center;
  font-size: 12px;
  height: 30px;
  outline: #1bc09c;
  font-family: Roboto-Bold;
}

.practice-test:hover {
  background: #1bc09c;
  box-shadow: 0 10px 20px 0 rgba(27, 192, 156, 0.4);
  color: #f2f2f2;
  outline: #1bc09c;
  cursor: pointer;
}

.practice-test:active {
  background: #1bc09c;
  border: 1px solid #1bc09c;
  color: white;
  outline: #1bc09c;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.horizontal-line {
  width: 326px;
  border: 0.5px solid #efeef3;
  padding-left: 18px;
  margin-right: 30px;
  margin-bottom: 8px;
}

.help-div {
  padding: 0px 32px;
  font-family: Roboto-Bold;
  letter-spacing: 0;
  font-size: 14px;
  margin-bottom: 42px;
}

.help-section {
  margin-top: auto;
}

#contact-administrator {
  font-family: Roboto-Regular;
  color: #9b9b9b;
  line-height: 20px;
}

#help-support {
  margin-top: 24px;
  font-family: Roboto-Bold;
  color: #616262;
  letter-spacing: 0;
}

#recommended-para {
  margin-top: 8px;
  color: #9b9b9b;
  line-height: 20px;
  font-family: Roboto-Regular;
}

#recommended {
  color: #616262;
}

.right-pane {
  display: flex;
  flex: 1;
  text-align: center;
  background: #f2f2f2;
  color: #69758b;
  height: 100%;
  overflow-y: auto;
  flex-direction: column;
}

.test-not-started-container {
  display: flex;
  flex: 1;
  flex-direction: column;
}

.date-countdown {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 48px;
  z-index: 5;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  font-family: 'Roboto-Medium';
  font-size: 16px;
  color: #0988f4;
}

.time-block {
  width: 44px;
}

.time-block .time-count {
  font-size: 28px;
}

.time-block .unit-text {
  font-size: 10px;
}

.colon {
  font-size: 24px;
}

.date-countdown .time-block {
  display: flex;
  flex-direction: column;
}

.timer-div {
  position: relative;
  background: #0988f4;
}

.time-container {
  display: flex;
  justify-content: center;
}

.timer-div .timer-img {
  padding: 32px;
  width: 420px;
  height: 420px;
}

.msg-container {
  display: flex;
  flex: 1;
  background: #ffffff;
  /*height: 65%;*/
}

.msg-div {
  display: flex;
  flex-direction: column;
  margin: 120px auto 0 auto;
}

.msg-div img {
  margin-top: 24px;
}

@media only screen and (max-width: 1440px) {
  .system-compatible {
    margin-left: 14px;
  }

  .system-compatible-msg {
    font-size: 12px;
    margin-left: 0px;
  }

  #left-pane {
    overflow-y: auto;
    max-width: 280px;
  }

  #image {
    margin: 16px auto;
    height: 150px;
  }

  .test-details-left-column {
    padding: 0px 16px;
    font-size: 13px;
  }

  .test-details-right-column {
    font-size: 13px;
    padding: 8px 0;
    min-width: 170px;
  }

  .horizontal-line {
    display: none;
    width: 240px;
  }

  .parent-test-details {
    margin-right: 17px;
    width: 280px;
  }

  .help-div {
    padding: 0px 16px;
    margin-bottom: 24px;
    font-size: 13px;
  }

  #sample-test {
    margin: 0 0 8px 32px;
    font-size: 18px;
  }

  #help-support {
    margin: 14px 0 8px 0;
  }

  #recommended {
    margin-bottom: 8px;
  }

  #contact-administrator,
  #recommended-para {
    margin-top: 8px;
  }

  .msg-div {
    margin: 60px auto 0 auto;
  }

  .timer-div .timer-img {
    padding: 16px;
    width: 360px;
    height: 360px;
  }
}
</style>
